import {generalRequest} from "@/lib/services/requests";
import {useMutation, useQuery} from "@tanstack/react-query";

export const useApiSearchAdminPollQuestionSurveyId = (args) => {

    return useQuery({
        queryKey: ['admin', 'poll', 'search', 'question', args],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (survey_id, config = {}) => {
            return generalRequest.get(`/admin/poll/questions/${survey_id}`, {params: config})
        })(args.survey_id, {
            ...args,
            page: pageParam
        })),
    })
}


export const useApiSearchAdminPollQuestionSurveyIdResult = (args) => {

    return useQuery({
        queryKey: ['admin', 'poll', 'search', 'question', args, 'result'],
        queryFn: ({pageParam = args.page ?? 1}) => ((async (survey_id, config = {}) => {
            return generalRequest.get(`/admin/poll/questions/${survey_id}/result`, {params: config})
        })(args.survey_id, {
            ...args,
            page: pageParam
        })),
    })
}


export const useApiReadAdminPollQuestionQuestionId = (survey_id, config) => {
    return useQuery({
        queryKey: ['admin', 'poll', 'get', survey_id],
        queryFn: () => ((async (question_id) => {
            if (!!question_id) {
                return generalRequest.get(`/admin/poll/question/${question_id}`)
            }
        })(survey_id)),
    })
}


export function useApiCreateAdminPollQuestion() {
    return useMutation({
        mutationFn: (data) =>
            ((async (data = {}) => {
                return generalRequest.post(`/admin/poll/question`, data)
            })(data))
    });

}


export function useApiUpdateAdminPollSurveySort() {
    return useMutation({
        mutationFn: (data) =>
            ((async (survey_id, sort = {}) => {
                return generalRequest.put(`/admin/poll/survey/${survey_id}/sort`, sort)
            })(data.survey_id, data))
    });

}


export function useApiUpdateAdminPollQuestionId() {
    return useMutation({
        mutationFn: ({id, data}) =>
            ((async (id, data = {}) => {
                return generalRequest.put(`/admin/poll/question/${id}`, data)
            })(id, data))
    });

}


export function useApiDeleteAdminPollQuestionId() {
    return useMutation({
        mutationFn: ({id, data}) =>
            ((async (id) => {
                return generalRequest.delete(`/admin/poll/question/${id}`)
            })(id, data))
    });

}

